import { TwinDictionary } from '../../../../../../../../../utils/globals/dictionary';
import { DictRemittanceBank, RemittanceDataFilters, RemittanceDataTy } from '../types';
import { checkBiggerDateSearch, checkSmallerDateSearch, numberMatchWithSearch, stringMatchWithSearch } from '../../../../../../../../../utils/globals/search';

const dictFilters: TwinDictionary = {
    'generalSearchbar': { fields: ['PayMCopy.Customer.name', 'PayTCopy.name', 'PayMCopy.SellInvoice.full_assigned_number', 'PayMCopy.SellInvoice.custom_name']},
    'from': { fields: ['date'], typeOfSearch: 'from' },
    'to': { fields: ['date'], typeOfSearch: 'to' },
    'PaymentMethodId': { fields: ['PayMCopy.PaymentMethodId'], typeOfSearch: 'PaymentMethodId'},
    'PaymentTypeId': { fields: ['PaymentTypeId'], typeOfSearch: 'PaymentTypeId'},
    'BankRemittanceLotId': { fields: ['BankRemittanceLot.id'], typeOfSearch: 'BankRemittanceLotId'}
}
const functionsByType: TwinDictionary = {
    general: stringMatchWithSearch,
    from: checkBiggerDateSearch,
    to: checkSmallerDateSearch,
    PaymentMethodId: numberMatchWithSearch,
    PaymentTypeId: numberMatchWithSearch,
    BankRemittanceLotId: numberMatchWithSearch
}

export const filterRemittanceData = (tableData: TwinDictionary[], filters: RemittanceDataFilters) => {
    const result: TwinDictionary[] = []
    const toSearch: [string, string][] = []
    if (filters.generalSearchbar !== '') {
        toSearch.push(['generalSearchbar', filters.generalSearchbar])
    }
    if (filters.singleFieldsSearch) {
        for (const key in filters.singleFieldsSearch) {
            toSearch.push([key, filters.singleFieldsSearch[key]])
        }
    }
    for (const element of tableData) {
        let mustAdd = true
        for (const toSearchItem of toSearch) {
            const [key, value] = toSearchItem
            const myField = dictFilters[key]
            const myFields = myField.fields
            const typeOfSearch = myField.typeOfSearch || 'general'
            const myFunction = functionsByType[typeOfSearch]
            let foundField = false
            for (const field of myFields) {
                if (myFunction(value, element[field])) {
                    foundField = true
                    break
                }
            }
            if (!foundField) {
                mustAdd = false
            }
        }
        if (mustAdd){
            result.push(element)
        }
    }
    return result
}

export const parseBankRemittanceLots = (completeData: RemittanceDataTy, dictWCBanks: DictRemittanceBank | null) => {
    const remittanceSelectedIds: number[] = []
    const dictBillingWorkingCenterBanks: TwinDictionary = {}
    if (completeData.selectedTableData){
        for (const element of completeData.selectedTableData) {
            const payMCopyDate = completeData.tableData[completeData?.dictPosTableData[element.id]]
            if (dictWCBanks?.[payMCopyDate?.['PayMCopy.BillingWorkingCenterId']] && !dictBillingWorkingCenterBanks[payMCopyDate?.['PayMCopy.BillingWorkingCenterId']]){
                const bank = dictWCBanks?.[payMCopyDate?.['PayMCopy.BillingWorkingCenterId']].items[dictWCBanks?.[payMCopyDate?.['PayMCopy.BillingWorkingCenterId']].value]
                dictBillingWorkingCenterBanks[payMCopyDate?.['PayMCopy.BillingWorkingCenterId']] = { id: bank.id, entity: bank.entity, iban: bank.iban}
            }
            remittanceSelectedIds.push(payMCopyDate.id)
        }
    }
    return { remittanceSelectedIds, dictBillingWorkingCenterBanks }
}